export default __webpack_public_path__ + "static/media/gallery-25.36f7e46f.jpg";